export default "__VITE_ASSET__CfO1For$__"